module.exports = __webpack_public_path__ + "media/images/countryrect/hu-e08ab4391d54bf200c44a57654e2df5f.svg";